import { render, staticRenderFns } from "./TeamProfilesTable.vue?vue&type=template&id=6ddad136&"
import script from "./TeamProfilesTable.vue?vue&type=script&lang=js&"
export * from "./TeamProfilesTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports